import React from 'react';

import ProgressBar from './ProgressBar';
import ProgressPill from './ProgressPill';

interface ProgressProps {
  progress: number;
  type?: 'big' | 'small';
}

const Progress = (props: ProgressProps) => {
  const { progress, type = 'small' } = props;
  if (!progress) {
    return null;
  }

  return type === 'small' ? <ProgressPill {...props} /> : <ProgressBar {...props} />;
};

export default React.memo(Progress);
